import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, as: Tag = "span", className = "" }) => {
  const MotionTag = motion[Tag] || motion.span;
  return (
    <span className="masked-line">
      <MotionTag
        initial={{ y: "110%" }}
        animate={{ y: "0%" }}
        transition={{ duration: 1, delay, ease: [0.22, 1, 0.36, 1] }}
        className={`block ${className}`}
      >
        {children}
      </MotionTag>
    </span>
  );
};

export const Eyebrow = ({ children }) => (
  <p className="font-mono-spec text-[11px] uppercase tracking-[0.3em] text-[#D4AF37]/90 mb-4" data-testid="section-eyebrow">
    {children}
  </p>
);
